import { createContext, ReactNode, useContext, useEffect, useReducer, useRef } from 'react';
import * as React from 'react';
import { initialState, AuthReducer, ActionTypes } from './Reducer';
import { loadState, LocalData, saveState } from '../shared/LocalStorage';


interface AuthProviderProps {
    children: ReactNode;
}

type AuthDispatch = (action: { type: ActionTypes; payload?: any }) => void;



const AuthStateContext = createContext<LocalData | undefined>(undefined);
const AuthDispatchContext = createContext<AuthDispatch | undefined>(undefined);


export function useAuthState(): LocalData {
    const context = useContext(AuthStateContext);
    if (context === undefined) {
        throw new Error('useAuthState must be used within a AuthProvider');
    }
    return context;
}


export function useAuthDispatch(): AuthDispatch {
    const context = useContext(AuthDispatchContext);
    if (context === undefined) {
        throw new Error('useAuthDispatch must be used within a AuthProvider');
    }
    return context;
}



export const AuthProvider = ({ children }: AuthProviderProps) => {



    // currently in Use
    var currentState = loadState();

    if (!currentState) {
        currentState = initialState;
        // console.log("initialState",currentState);
    }
    // console.log("auth_provider",currentState);

    const [user, dispatch] = useReducer(AuthReducer, currentState);

    return (
        <AuthStateContext.Provider value={user} >
            <AuthDispatchContext.Provider value={dispatch}>
                {children}
            </AuthDispatchContext.Provider>
        </AuthStateContext.Provider>
    );
};
